import type { ObjectType } from '@quromedical/fhir-common';
import type { GroupMembers } from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field, SelectOption } from 'components/types';
import { practitionerFetcher } from 'integration';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';
import * as yup from 'yup';

interface AddMemberFormProps {
  onSubmit: (data: GroupMembers[]) => void;
}
type FormData = {
  members: SelectOption<GroupMembers[]>;
};

export const createFields = (): Field<FormData>[] => [
  {
    subfields: [
      {
        key: 'members',
        label: strings.FormLabelMembers,
        type: 'combobox-multiple',
        searchable: true,
        initialSelection: [],
        fetcher: practitionerFetcher,
        returnFullOption: true,
      },
    ],
  },
];

const schema = yup.object<ObjectType<FormData>>({
  members: yup.array(yup.object().required()).required().min(1),
});

export const AddMemberForm: React.FC<AddMemberFormProps> = ({ onSubmit }) => {
  const handleSubmit = useCallback(
    (data: FormData) => {
      const members = Array.isArray(data.members)
        ? data.members.map((member) => ({
            id: member.value,
            display: member.display,
          }))
        : [];

      try {
        onSubmit(members);
        return {};
      } catch (error) {
        return { error };
      }
    },
    [onSubmit],
  );

  const fields = createFields();

  return (
    <CrudForm
      title={strings.CardTitleAddGroupMembers}
      onSubmit={handleSubmit}
      fields={fields}
      initialValues={{}}
      buttonText="Submit"
      validationSchema={schema}
    />
  );
};
